import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="min-h-[70vh] grid place-items-center">
      <div className="text-center max-w-md px-6">
        <div className="overline mb-2">404</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white">This page is off the grid</h1>
        <p className="mt-3 text-ink-400">The page you&apos;re looking for has moved, been renamed, or never existed.</p>
        <Link to="/" className="btn-primary mt-8" data-testid="not-found-home">
          <HomeIcon className="h-4 w-4" /> Back to home
        </Link>
      </div>
    </main>
  );
}
